import React from "react";
import { Student } from "@/types/Student";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/Avatar";

const FACE_PILE_COUNT = 4;

export const FacePile = ({
  students,
  loading = true,
}: {
  students: Student[];
  loading?: boolean;
}) => {
  if (loading) {
    return (
      <div className="flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background">
        {Array.from({ length: FACE_PILE_COUNT }).map((i, idx) => (
          <Avatar key={idx}>
            <AvatarFallback />
          </Avatar>
        ))}
      </div>
    );
  }
  return (
    <div className="flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background">
      {students.slice(0, FACE_PILE_COUNT).map((student) => (
        <Avatar key={student.id}>
          <AvatarImage
            src={student.imageUrl?.url}
            alt={student.studentOrganizationStatus?.name || ""}
          />
          <AvatarFallback>
            {student.studentOrganizationStatus?.name
              ?.split(" ", 2)
              .map((part) => part?.[0] || "")
              .join("") || "U"}
          </AvatarFallback>
        </Avatar>
      ))}
    </div>
  );
};
